import * as types from './mutations-types'

export default {

  // ログイン結果の認証情報を格納
  [types.AUTH_LOGIN] (state, payload) {
    state.auth = payload
  },

  // ログアウト
  [types.AUTH_LOGOUT] (state, payload) {
    state.auth = payload
  },

  [types.CODE_DEF_LIST] (state, payload) {
    state.codeDefList = payload

    const prefDomainCode = 'A001101'
    const prefDomainCodeEn = 'A001102'

    const prefCodeList = state.codeDefList.filter(codeDef => codeDef.domainCd === prefDomainCode)
    state.prefCodeList = prefCodeList
      .map(item => ({
        kbnCd: item.kbnCd,
        kbnVal: {
          ja: item.kbnVal,
          en: state.codeDefList.find(codeDefItem => codeDefItem.domainCd === prefDomainCodeEn && codeDefItem.kbnCd === item.kbnCd).kbnVal
        }
      })
      )

    // チームコード-Jリーグ
    const clubJDomainCode = 'A002101'
    const clubJDomainCodeEn = 'A002102'
    const clubJCodeList = state.codeDefList.filter(codeDef => codeDef.domainCd === clubJDomainCode)
    state.clubJCodeList = clubJCodeList
      .map(item => ({
        kbnCd: item.kbnCd,
        kbnVal: {
          ja: item.kbnVal,
          en: state.codeDefList.find(codeDefItem => codeDefItem.domainCd === clubJDomainCodeEn && codeDefItem.kbnCd === item.kbnCd).kbnVal
        }
      })
      )

    // チームコード-WEリーグ
    const clubWEDomainCode = 'A002201'
    const clubWEDomainCodeEn = 'A002202'
    const clubWECodeList = state.codeDefList.filter(codeDef => codeDef.domainCd === clubWEDomainCode)
    state.clubWECodeList = clubWECodeList
      .map(item => ({
        kbnCd: item.kbnCd,
        kbnVal: {
          ja: item.kbnVal,
          en: state.codeDefList.find(codeDefItem => codeDefItem.domainCd === clubWEDomainCodeEn && codeDefItem.kbnCd === item.kbnCd).kbnVal
        }
      })
      )
  },

  [types.AUTH_TOKEN] (state, payload) {
    state.auth = payload
  },

  [types.IS_LOADING] (state, payload) {
    state.isLoading = payload
  },

  [types.IS_LANG_JA] (state, payload) {
    state.isLangJa = payload
  },

  [types.FORM_ADMIN_ACCOUNT_ENTRY_LIST] (state, payload) {
    state.form.adminAccountEntryList = payload
  },

  [types.FORM_ADMIN_ACCOUNT_LIST] (state, payload) {
    state.form.adminAccountList = payload
  },

  [types.FORM_ADMIN_MST_COMANY_LIST] (state, payload) {
    state.form.adminMstCompanyList = payload
  },

  [types.FORM_ADMIN_ACCOUNT_SERVICE_APPLICATION_LIST] (state, payload) {
    state.form.adminAccountServiceApplicationList = payload
  },

  [types.FROM_ADDRESS_LIST] (state, payload) {
    state.form.fromAddressList = payload
  }
}
